export default __webpack_public_path__ + "static/media/Beckhoff Automation.8d1cde6d.png";